const ProductDetails = {};

ProductDetails.formatPlatform = (platform) => {
  if (platform === 'drm_free') return false;
  if (platform === 'oculus') return false;
  if (platform === 'epicgames') return 'Epic Games';
  if (platform === 'uplay') return 'Ubisoft Connect';
  return platform;
};

ProductDetails.formatXboxPlatform = (platform) => {
  if (platform === 'xbox_series_x_s') return 'Xbox Series X|S';
  if (platform === 'xbox_one') return 'Xbox One';
  if (platform === 'windows_10_11') return 'Windows 10/11';
  return platform;
};

export default ProductDetails;
